'use client'

import { Button, Spacer, Stack, StackItem, Text } from '@vinted/web-ui'

import { useAsset } from '@marketplace-web/shared/assets'

type Props = {
  title: string
  body: string
  action: string
  onActionClick: () => void
}

const ASSET_BASE = 'assets/error-page'
const ASSET_DIMENSION = 256

const ErrorContent = ({ title, body, action, onActionClick }: Props) => {
  const asset = useAsset(ASSET_BASE)

  return (
    <div className="fullpage-layout u-background-white small-container u-flexbox u-justify-content-center u-align-items-center u-flex-grow error-display">
      <Stack direction="column" alignment="center" distribution="center">
        <Spacer size="x2-large" />
        <video
          muted
          playsInline
          autoPlay
          loop
          width={ASSET_DIMENSION}
          height={ASSET_DIMENSION}
          poster={asset('error.png')}
        >
          <source src={asset('error.mp4')} type="video/mp4" />
          <source src={asset('error.webm')} type="video/webm" />
        </video>

        <Stack padding="x-large" direction="column" alignment="center">
          <Text as="h1" text={title} type="heading" alignment="center" testId="error-page-title" />
          <Spacer size="x-large" />
          <Text as="span" text={body} alignment="center" testId="error-page-body" />
        </Stack>
        <StackItem alignSelf="center">
          <Button onClick={onActionClick} text={action} styling="filled" />
        </StackItem>
        <Spacer size="x2-large" />
      </Stack>
    </div>
  )
}
export default ErrorContent
